export enum RouteHeaderName {
  Dashboard = "Dashboard",
  Bookings = "Bookings",
  Calendar = "Calendar",
  Theaters = "Theaters",
  Seats = "Seats",
  Settings = "Settings",
  Payments = "Payments",
  Users = "Users",
  Content = "Content",
  ImportBookings = "Import",
  Logs = "Logs",
}
